<template>
    <section>
        <div class="sticky-bora-webstore">
            <header-view></header-view>
            <header2></header2>
        </div>
        <div style="padding-top:125px">
            <transition name="fade">
                <router-view></router-view>
            </transition>
        </div>
    </section>
</template>

<script>
    import Header from '@components/Header.vue'
    import Header2 from '@components/Header2.vue'

    export default{
        components:{
            HeaderView:Header,
            Header2
        }
    }
</script>

<style>
.sticky-bora-webstore {
    position: fixed;
    background: #8c2c1e;
    top: 0;
    width: 100%;
    z-index: 999990;
  }
</style>



// WEBPACK FOOTER //
// BasePage.vue?2d06d5e6